import React from 'react';
import { ClipboardCopy } from '@patternfly/react-core';

/**
 * Shared display helpers for the certificate views (overview / X.509 /
 * CA bundle), so empty-value fallbacks and the copyable monospace rendering
 * stay identical across them.
 */

/** Em-dash fallback for absent string fields. */
export function text(value: string | null | undefined): string {
  return value !== null && value !== undefined && value !== '' ? value : '—';
}

/**
 * Inline copy-to-clipboard rendering for identifier-ish values
 * (fingerprints, serials, DNs, platform refs); `label` feeds the
 * `aria-label` of the copy button.
 */
export function copyable(value: string | null | undefined, label: string): React.ReactNode {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return (
    <ClipboardCopy
      variant="inline-compact"
      isCode
      truncation
      hoverTip="Copy"
      clickTip="Copied"
      copyAriaLabel={`Copy ${label}`}
    >
      {value}
    </ClipboardCopy>
  );
}
